(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.RSSCompare = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function normalizeProduct(product) {
    if (typeof product === 'string') return { handle: product };
    if (!product || typeof product !== 'object' || !product.handle) return null;
    return {
      handle: String(product.handle),
      title: String(product.title || ''),
      url: String(product.url || ''),
      image: String(product.image || ''),
      price: String(product.price || ''),
      workspace: String(product.workspace || ''),
      frame: String(product.frame || ''),
      automation: String(product.automation || ''),
      bestFor: String(product.bestFor || '')
    };
  }

  function normalizeSelection(raw, max) {
    const limit = Number.isFinite(max) ? max : 3;
    if (!Array.isArray(raw)) return [];
    const seen = new Set();
    const result = [];
    raw.forEach((candidate) => {
      const product = normalizeProduct(candidate);
      if (!product || seen.has(product.handle) || result.length >= limit) return;
      seen.add(product.handle);
      result.push(product);
    });
    return result;
  }

  function toggleSelection(current, product, checked, max) {
    const limit = Number.isFinite(max) ? max : 3;
    const previous = normalizeSelection(current, limit);
    const candidate = normalizeProduct(product);
    if (!candidate) return { selection: previous, limitReached: false, shouldOpen: false };

    let selection = previous.filter((item) => item.handle !== candidate.handle);
    let limitReached = false;
    if (checked) {
      if (selection.length >= limit) limitReached = true;
      else selection.push(candidate);
    }
    selection = normalizeSelection(selection, limit);
    return {
      selection,
      limitReached,
      shouldOpen: checked && previous.length < 2 && selection.length >= 2
    };
  }

  return { normalizeSelection, toggleSelection };
});
